import { Grid, Typography } from '@mui/material';
import { FormikHelpers } from 'formik';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from '../../../core/ui/layout/Layout';
import { useSendApiData } from '../../../core/hooks/useSendApiData';
import { toastError, toastMessage } from '../../../core/utils/ui/alert';
import { parseValidationErrors } from '../../../core/utils/validation';
import useFetchApiData from '../../../core/hooks/useFetchApiData';
import Loader from '../../../core/ui/utility/Loader';
import { StrategicPlanEdit, StrategicPlan } from '../strategicPlan';
import EditStrategicPlanForm from '../components/EditStrategicPlanForm';
import ReturnButton from '../../../core/ui/utility/ReturnButton';
import { parseFormQuery } from '../../../core/utils/utility';

const EditStrategicPlanContainer = () => {
  const { id } = useParams();
  const { callApi, loading: submitting } = useSendApiData();
  const { fetchData, loading } = useFetchApiData();
  const [strategicPlan, setStrategicPlan] = useState<StrategicPlan | null>(
    null
  );

  const fetchStrategicPlan = () =>
    fetchData(`strategic-plans/${id}`, {
      onSuccess: (data: StrategicPlan) => {
        setStrategicPlan(data);
      },
    });

  useEffect(() => {
    fetchStrategicPlan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    values: StrategicPlanEdit,
    { setFieldError }: FormikHelpers<StrategicPlanEdit>
  ) => {
    const formData: any = parseFormQuery(values, []);

    await callApi({
      endpoint: `auth-phe24/strategic-plans/${id}?_method=PATCH`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onValidationError: (err) => parseValidationErrors(err, setFieldError),
      onError: toastError,
      onSuccess: async (_) => {
        await fetchStrategicPlan();
        toastMessage('StrategicPlan Edited');
      },
    });
  };

  return (
    <Layout renderLeftToolbar={() => <ReturnButton to="/strategic-plans" />}>
      <Loader loading={loading || !strategicPlan}>
        <Grid sx={{ p: 2 }}>
          <Grid container sx={{ mb: 1, px: 1 }}>
            <Typography variant="h5">Edit Strategic Plan</Typography>
          </Grid>
          <EditStrategicPlanForm
            strategicPlan={strategicPlan!}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        </Grid>
      </Loader>
    </Layout>
  );
};

export default EditStrategicPlanContainer;
